if (!customElements.get('klaim-sticky-atc')) {
  customElements.define(
    'klaim-sticky-atc',
    class KlaimStickyAtc extends HTMLElement {
      connectedCallback() {
        this.stickyButton = this.querySelector('.klaim-sticky-atc__button');
        this.productInfo = this.closest('product-info');

        if (!this.stickyButton || !this.productInfo) return;

        this.handleStickyClick = () => {
          const originalButton = this.productInfo.querySelector('.product-form__submit');
          if (originalButton && !originalButton.disabled) originalButton.click();
        };

        this.updateStickyState = () => {
          if (this.frameRequested) return;

          this.frameRequested = true;
          requestAnimationFrame(() => {
            this.frameRequested = false;

            const originalButton = this.productInfo.querySelector('.product-form__submit');
            if (!originalButton) {
              this.dataset.visible = 'false';
              this.setAttribute('aria-hidden', 'true');
              return;
            }

            const originalRect = originalButton.getBoundingClientRect();
            const headerBottom = document.querySelector('header')?.getBoundingClientRect().bottom || 0;
            const isMobile = window.matchMedia('(max-width: 749px)').matches;
            const isPastOriginalButton = originalRect.bottom <= Math.max(0, headerBottom);
            const shouldShow = isMobile && isPastOriginalButton;

            this.dataset.visible = shouldShow ? 'true' : 'false';
            this.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
            this.stickyButton.disabled = originalButton.disabled;
            this.stickyButton.tabIndex = shouldShow ? 0 : -1;
            this.stickyButton.textContent = originalButton.disabled ? 'Sold out' : 'Add to bag';
          });
        };

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.updateStickyState);
        }

        this.stickyButton.addEventListener('click', this.handleStickyClick);
        window.addEventListener('scroll', this.updateStickyState, { passive: true });
        window.addEventListener('resize', this.updateStickyState);
        this.updateStickyState();
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
        this.stickyButton?.removeEventListener('click', this.handleStickyClick);
        window.removeEventListener('scroll', this.updateStickyState);
        window.removeEventListener('resize', this.updateStickyState);
      }
    }
  );
}
